// 导入基本公共资源
import http from './../../../base/api/public'
// nodejs的 querystring 模块提供用于解析和格式化 URL 查询字符串的实用工具
// get请求时需要使用的到
// import querystring from 'querystring'
let sysConfig = require('@/../config/sysConfig')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
let service = require('@/../config/serviceList')

export default {
  // 站
  getCascaderOptions(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(`${apiPre}` + service.res + '/res/station/getCascaderOptions', params)
  },

  getStartCharge(params) {
    console.log('params:' + JSON.stringify(params));
    return http.requestPost(`${apiPre}` + service.res + '/res/deviceControl/startCharge', params)
  },
  faultListing(params){
    console.log('params:' + JSON.stringify(params));
    return http.requestGet(apiPre + service.res + '/res/deviceControl/faultListing/'+params)
  },
  inspectionAndMaintenance(params){
    console.log('params:' + JSON.stringify(params));
    return http.requestGet(apiPre + service.res + '/res/deviceControl/inspectionAndMaintenance/'+params)
  },
  powerControl(params){
    console.log('params:' + JSON.stringify(params));
    return http.requestPut(apiPre + service.res + '/res/deviceControl/powerControl',params)
  },
  getGunsPageList(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/deviceControl/getList', params)
  },
  getPilePageList(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/deviceControl/getPiles', params)
  },
  getLimitedTimeCharging(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/deviceControl/limitedTimeCharging', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/operatingCenter/api/deviceControlApi.js